import { useRef, useEffect } from 'react';

function useUpdate(effect, deps) {
  var applyChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isInitialMount = useRef(true);
  useEffect(isInitialMount.current || !applyChanges ? function () {
    isInitialMount.current = false;
  } : effect, deps);
}

export default useUpdate;